<template>
  <div class="app-activation-auto-top-up-wrapper">
    <div class="container-box">
        <div class="content-limiter space-bottom-sm">
          <h2 class="text-3xl">Aufladung</h2>
          <p class="top-up-text">
            Richte hier deine Aufladeart ein, um sicherzustellen, dass immer ausreichend Guthaben für deinen Tarif vorhanden
            ist. Die Bezahlung erfolgt über dein <span lang="en">Prepaid</span>-Guthaben. Ist dieses nicht ausreichend, wird der
            Tarif pausiert (<span class="uppercase">classic</span>-Konditionen) und bei Aufladung wieder aktiviert. Mit der
            automatischen Aufladung bleibt dein Konto stets gedeckt. Wähle einen Aufladebetrag und eine Guthabengrenze, die
            mindestens deinen monatlichen Tarifkosten entsprechen.<br />
            <br />
            <strong>Bitte beachte:</strong> Die mit * gekennzeichneten Felder sind Pflichtfelder und müssen ausgefüllt werden.
          </p>
        </div>
        <div class="topUp-selector">
          <button type="button" class="button button--grey --fit-content toggle-topUp" data-card="card1">
            Guthaben
          </button>
          <button type="button" class="button button--grey --fit-content toggle-topUp" data-card="card2">
            Monatlich
          </button>
          <button type="button" class="button button--primary --fit-content toggle-topUp card3-button" data-card="card3">
            Ohne
          </button>
        </div>
        <p v-show="displayError" class="text-error">
          Bitte eine der Optionen auswählen
        </p>
        <div class="topUp-cards-container">
          <EnterAutoTopUp
            :top-up="autoTopUp_"
            :trigger.sync="autoTopUp_.trigger"
            :amount.sync="autoTopUp_.amount"
            :monthly-value="monthlyValue"
            :inside-activation="true"
            @threshold="change_v2('threshold')"
            @monthly="change_v2('monthly')"
          >
            <template v-for="slot in possibleChildSlotsFor('AutoTopUp')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </EnterAutoTopUp>
          <div class="hide"></div>
          <div class="topUp-cards-wrapper card3">
            <div class="topUp-card">
              <div class="topUp-card-header">
                <img src="/files/lidl/images/new-icons/svg/close_white.svg" alt="" />
                <span class="text-xl text-semibold">Keine Aufladung</span>
              </div>
              <div class="topUp-card-body">
                <div class="body-element">
                  <div class="info">
                    <p class="text-sm">
                      Du kannst dein <span class="uppercase">Lidl</span> <span lang="en">Connect</span> Guthaben zu einem
                      späteren Zeitpunkt anpassen.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <button id="without" class="button button--secondary" value="without" @click.prevent="change_v2('without')">
              Auswählen
              <img src="/files/lidl/images/new-icons/svg/check.svg" alt="" />
            </button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// import EnterSingleTopUp from '@/components/process/LIDL/Activation/TopUp/EnterSingleTopUp.vue'
import EnterAutoTopUp from '@/components-v2/flows/LIDL/Activation/TopUp/EnterAutoTopUp.vue'
import syncProperty from '@/mixins/syncProperty'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'EnterAutoSingleTopUp',
  mixins: [
    syncProperty('autoTopUp', 'autoTopUp_'),
    syncProperty('singleTopUp', 'singleTopUp_'),
    syncProperty('selectedTopUpTypes', 'selectedTopUpTypes_'),
    transaction('activation'),
    slotProxy()
  ],
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    }
  },
  watch: {
    // automatically select the checkbox for single or auto topup if an deeper option is selected
    singleTopUp_: {
      immediate: true,
      handler: function(value, old) {
        if (this.selectedTopUpTypes.includes('single') === false && old !== undefined) {
          this.change([...this.selectedTopUpTypes, 'single'], 'single')
        }
      }
    },
    autoTopUp_: {
      deep: true,
      handler: function(value) {
        if (value.type === 'monthly' && value.trigger === null) {
          value.trigger = this.monthlyValue[0]
        }
        if (this.selectedTopUpTypes.includes('auto') === false) {
          this.change([...this.selectedTopUpTypes, 'auto'], 'auto')
        }
      }
    }
  },
  methods: {
    change_v2(changedItem) {
      if (this.selectedTopUpTypes_.includes(changedItem)) {
        // prevents any action on clicking if clicked button is already selected
        return
      }

      const buttons = {
        // buttons for topUp selection
        threshold: document.getElementById('threshold'),
        monthly: document.getElementById('monthly'),
        without: document.getElementById('without')
      }
      this.selectedTopUpTypes_ = [changedItem]
      Object.entries(buttons).forEach(([key, button]) => {
        // switches buttons style based on clicked button
        const isActive = key === changedItem
        button.classList.toggle('button--primary', isActive)
        button.classList.toggle('button--secondary', !isActive)
        button.innerHTML = isActive ? 'Ausgewählt <img src="/files/lidl/images/new-icons/svg/check.svg" alt="">' : 'Auswählen'
      })
      if (changedItem === 'threshold') {
        this.autoTopUp_.type = 'byLimit'
      } else if (changedItem === 'monthly') {
        this.autoTopUp_.type = 'monthly'
        this.autoTopUp_.trigger = null
      } else if (changedItem === 'nothing') {
        this.autoTopUp_.type = 'nothing'
        this.autoTopUp_.trigger = null
      }
    },
    handleResize() {
      // if window is big enough all card will be displayed normal
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight

      const cards = document.querySelectorAll('.topUp-cards-container > .topUp-cards-wrapper') // get all card
      const wrapper = document.getElementById('app-auto-top-up') // get wrapper of first 2 cards

      if (window.innerWidth > 768) {
        // checks if window is bigger than mobile. If that the case all cards will be displayed
        wrapper.style.display = 'flex'
        cards.forEach(card => {
          card.style.display = 'flex'
        })
      }
      if (window.innerWidth < 768) {
        // checks if window is smaller than mobile. If that the case all cards expect of the second will be displayed
        cards.forEach(card => {
          if (card.classList.contains('card2')) {
            card.style.display = 'flex'
          } else {
            card.style.display = 'none'
          }
        })
      }
    },
    change(newValue, changedItem) {
      if (newValue.includes('without') && newValue.length > 1) {
        // invalid!, without + 1 other option
        if (changedItem === 'without') {
          // last change was clicking without -> all other values must be deselected
          this.selectedTopUpTypes_ = ['without']
        } else {
          // clicked anoter, without must be removed
          this.selectedTopUpTypes_ = [...newValue.filter(item => item !== 'without')]
        }
      } else if (newValue.length === 0) {
        // empty is not good, select all available types
        if (changedItem === 'without') {
          this.selectedTopUpTypes_ = ['auto', ...(this.showSingleTopUp ? ['single'] : [])]
        } else {
          this.selectedTopUpTypes_ = ['without']
        }
      } else {
        this.selectedTopUpTypes_ = newValue
      }
    }
  },
  mounted() {
    const setupToggleButtons = () => {
      const buttons = document.querySelectorAll('.toggle-topUp')
      const cards = document.querySelectorAll('.topUp-cards-container > .topUp-cards-wrapper')
      const wrapper = document.getElementById('app-auto-top-up')

      buttons.forEach(button => {
        button.addEventListener('click', function() {
          buttons.forEach(btn => {
            btn.classList.remove('button--primary')
            btn.classList.add('button--grey')
          })

          if (button.classList.contains('card3-button')) {
            wrapper.style.display = 'none'
          } else {
            wrapper.style.display = 'flex'
          }

          button.classList.remove('button--grey')
          button.classList.add('button--primary')

          cards.forEach(card => {
            card.style.display = 'none'
          })

          const cardToShow = document.querySelector(`.${button.dataset.card}`)
          if (cardToShow) {
            cardToShow.style.display = 'block'
          }
        })
      })
    }
    this.change_v2('nothing') // default value for top up
    window.addEventListener('resize', this.handleResize)
    setupToggleButtons()
  },
  computed: {
    isAnnualTarrif: function() {
      return this.selectedTariff?.tariffExtra?.type === 'year'
    },
    alertSingleTopUp: function() {
      return !this.selectedTopUpTypes.includes('single')
    },
    alertAutoTopUp: function() {
      return !this.selectedTopUpTypes.includes('auto')
    },
    defaultValueSingleTopUp: function() {
      if (this.selectedTariff?.tariffExtra?.type === 'year') {
        return this.selectedTariff?.tariffExtra?.singleTopUp
      }
      return this.singleTopUp_ || this.possibleSingleTopUpAmounts.default
    },
    splittedTopUp: {
      get: function() {
        if (this.autoTopUp_.type === 'monthly') {
          if (this.autoTopUp_.trigger === null) {
            return {
              type: this.autoTopUp_.type,
              trigger: this.monthlyValue[0]
            }
          }
          return {
            type: this.autoTopUp_.type,
            trigger: this.autoTopUp_.trigger
          }
        }
        return {
          type: this.autoTopUp_.type
        }
      },
      set: function(value) {
        this.autoTopUp_.type = value.type
        if (value.type === 'withoutAuto') {
          this.autoTopUp_.trigger = null
          this.autoTopUp_.amount = null
        }
        if (value.type === 'monthly') {
          this.autoTopUp_.trigger = value.trigger
        }
      }
    }
  },
  components: { EnterAutoTopUp },
  props: ['monthlyValue', 'possibleSingleTopUpAmounts', 'showSingleTopUp', 'showAutoTopUp', 'selectedTariff', 'displayError']
}
</script>
